import { useState } from 'react';
import { useTheme } from '../../context/ThemeContext';
import { changePasswordApi } from '../../utils/apis';

export default function Setting() {
  // return (
  //   <div className='h-screen'>Setting</div>
  // )
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const { theme } = useTheme();
  const handleSubmit = async (e: any) => {
    e.preventDefault();

    // Reset error and success messages
    setError('');
    setSuccess('');

    // Validate form inputs
    if (!currentPassword || !newPassword || !confirmPassword) {
      setError('All fields are required.');
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('New passwords do not match.');
      return;
    }

    if (newPassword.length < 8) {
      setError('Password must be at least 8 characters long.');
      return;
    }

    const response = await changePasswordApi(currentPassword, newPassword);
    if (!response) {
      setError('Failed to change password. Please try again.');
      return;
    }
    // Simulate a successful password change
    setTimeout(() => {
      setSuccess('Password changed successfully!');
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
    }, 1000);
  };

  return (
    <div className="h-screen max-w-md mx-auto px-4 sm:px-6">
      <h2 className="text-2xl font-bold p-4 text-center">Change Password</h2>
      {error && (
        <div className="bg-red-100 text-red-700 p-2 rounded mb-4">{error}</div>
      )}
      {success && (
        <div className="bg-green-100 text-green-700 p-2 rounded mb-4">
          {success}
        </div>
      )}
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label
            className="block text-gray-700 font-medium mb-2"
            htmlFor="currentPassword"
          >
            Current Password
          </label>
          <input
            type="password"
            id="currentPassword"
            className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-${theme.color}-300`}
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
          />
        </div>
        <div className="mb-4">
          <label
            className="block text-gray-700 font-medium mb-2"
            htmlFor="newPassword"
          >
            New Password
          </label>
          <input
            type="password"
            id="newPassword"
            className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-${theme.color}-300`}
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
        </div>
        <div className="mb-4">
          <label
            className="block text-gray-700 font-medium mb-2"
            htmlFor="confirmPassword"
          >
            Confirm New Password
          </label>
          <input
            type="password"
            id="confirmPassword"
            className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-${theme.color}-300`}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
        </div>
        <button
          type="submit"
          className={`w-full  text-white py-2 px-4 rounded-lg focus:outline-none focus:ring ${theme['button-bg']}`}
          // bg-teal-500 hover:bg-teal-600 focus:ring-teal-300
        >
          Change Password
        </button>
      </form>
    </div>
  );
}
